// Client wrappers for /api/tars. Player_id is forced from session
// cookie server-side — no body field. credentials:'include' carries
// somesay_session.

const TRIP_DEFAULT = 'juneau-2026';

export async function fetchTars({ tripId = TRIP_DEFAULT } = {}) {
  const res = await fetch(`/api/tars?trip_id=${encodeURIComponent(tripId)}`, {
    credentials: 'include',
  });
  if (!res.ok) {
    const detail = await res.json().catch(() => ({}));
    const err = new Error(detail.message || detail.error || `tars → ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return res.json();
}

export async function saveTars({ tripId = TRIP_DEFAULT, humor, honesty, sarcasm }) {
  const res = await fetch('/api/tars', {
    method: 'PUT',
    credentials: 'include',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ trip_id: tripId, humor, honesty, sarcasm }),
  });
  if (!res.ok) {
    const detail = await res.json().catch(() => ({}));
    const err = new Error(detail.message || detail.error || `tars save → ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return res.json();
}

export async function previewTars({ tripId = TRIP_DEFAULT, humor, honesty, sarcasm, text }) {
  const res = await fetch('/api/tars', {
    method: 'POST',
    credentials: 'include',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ trip_id: tripId, humor, honesty, sarcasm, text }),
  });
  if (!res.ok) {
    const detail = await res.json().catch(() => ({}));
    const err = new Error(detail.message || detail.error || `tars preview → ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return res.json();
}
